import type {ReactElement} from 'react';
import {useRef} from 'react';
import React from 'react';
import type {TemplateStyleThumbnailProps} from './template-style-thumbnail.types';
import styles from './template-style-thumbnail.module.scss';
import {ContextualMenuThumbnailItem} from '@Components/contextual-menu/components/contextual-menu-thumbnail-item';
import {useInViewport} from 'ahooks';
import {Thumbnail} from '@Components/thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {getAssetUrl} from '@Utils/s3.util';
import {SUBTITLE_TEMPLATE_STYLE_THUMBS_URL} from '@PosterWhiteboard/items/transcript-item/subtitle/subtitle.types';
import {getCompatibleVideoFileExtension} from '@Utils/video.util';

export function TemplateStyleThumbnail({isLoading = false, isMobile = false, isSelected = false, ...props}: TemplateStyleThumbnailProps): ReactElement {
  const ref = useRef<HTMLDivElement | null>(null);
  const isInViewPort = useInViewport(ref);

  const getClasses = (): string => {
    return isMobile ? styles.thumbItemMobileContainer : styles.thumbItemContainer;
  };

  const getThumbnailItem = (): ReactElement => {
    return (
      <ContextualMenuThumbnailItem
        id={props.id}
        key={props.id}
        isDisabled={isLoading}
        className={`spacing-m-0 ${getClasses()}`}
        thumbnailContainerClassName={`radius-12 ${getClasses()}`}
        hasBorder
        isSelected={isSelected}
        thumbnail={
          <Thumbnail
            className={`radius-12 ${isMobile ? styles.thumbImageMobile : styles.thumbImage}`}
            data={{
              type: ThumbnailType.IMAGE,
              showSkeletonLoading: true,
              disabled: isLoading,
              imageSrc: getAssetUrl(`${SUBTITLE_TEMPLATE_STYLE_THUMBS_URL}${props.id}.${getCompatibleVideoFileExtension('gif')}?ts=${new Date().getTime()}`),
            }}
          />
        }
        onClick={props.onSelected}
      />
    );
  };

  const getItem = (): ReactElement => {
    return (
      <div className={getClasses()} ref={ref}>
        {isInViewPort[0] ? React.cloneElement(getThumbnailItem(), {}) : null}
      </div>
    );
  };

  return getItem();
}
